module.exports = __webpack_public_path__ + "static/img/4机械式放气调节装置.2a66ca06.jpg";